export const iconFontAwesomeEditingGear = (
	<i className="fa-solid fa-gear"></i>
);
